import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ITable, ITablesLayoutEntry } from '../../interfaces/ITable';
import { IOrder } from '../../interfaces/IOrder';

const apiUrl = Globals.apiPath + '/tables';

/** Body of `POST /tables` (the fields the API's `create` destructures). */
export interface ICreateTableDto {
  restaurantId: number;
  branchId: number;
  name: string;
  capacity: number;
  description?: string;
}

export default class TablesService {
  constructor() {}

  static async getAll(
    restaurantId: number,
    branchId: number
  ): Promise<ITable[]> {
    let res = await axios.get<ITable[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}`
    );
    const tables = res.data;

    // Sort by name asc
    tables.sort((a, b) =>
      a.name.localeCompare(b.name, undefined, {
        numeric: true,
        sensitivity: 'base',
      })
    );

    return tables;
  }

  async getById(id: number): Promise<ITable> {
    let res = await axios.get<ITable>(`${apiUrl}/${id}`);
    return res.data;
  }

  async getActiveOrders(id: number): Promise<IOrder[]> {
    let res = await axios.get<IOrder[]>(`${apiUrl}/${id}/orders`);
    return res.data;
  }

  async getActiveOrdersCount(id: number): Promise<number> {
    let res = await axios.get<number>(`${apiUrl}/${id}/ordersCount`);
    return res.data;
  }

  async create(table: ITable): Promise<ITable> {
    let res = await axios.post<ITable>(apiUrl, table);
    return res.data;
  }

  /** Creates one table from its own fields (the setup guide's zero-table path). */
  static async createTable(dto: ICreateTableDto): Promise<ITable> {
    const res = await axios.post<ITable>(apiUrl, dto);
    return res.data;
  }

  async update(table: ITable): Promise<ITable> {
    let res = await axios.put<ITable>(`${apiUrl}/${table.id}`, table);
    return res.data;
  }

  async delete(table: ITable): Promise<ITable> {
    let res = await axios.put<ITable>(`${apiUrl}/${table.id}`);
    return res.data;
  }

  static async close(tableId: number): Promise<IOrder[]> {
    let res = await axios.post<IOrder[]>(`${apiUrl}/${tableId}/close`);
    return res.data;
  }

  /** Batch-writes floor-plan geometry. Returns the changed tables. */
  static async saveLayout(input: {
    restaurantId: number;
    branchId: number;
    entries: ITablesLayoutEntry[];
  }): Promise<ITable[]> {
    const res = await axios.put<ITable[]>(`${apiUrl}/layout`, input);
    return res.data;
  }

  async activate(table: ITable): Promise<ITable> {
    let res = await axios.post<ITable>(`${apiUrl}/${table.id}/activate`);
    return res.data;
  }

  async deactivate(table: ITable): Promise<ITable> {
    let res = await axios.post<ITable>(`${apiUrl}/${table.id}/deactivate`);
    return res.data;
  }
}
